import React from "react";
import ImportadorExcelGenerico from "../../../../Components/ImportadorExcelGenerico";
import {
  ETIQUETAS_ACCION,
  columnaOperacion,
  mostrarResumenImportacion,
} from "../../../../Components/importarAsignacionesUI";
import {
  NOMBRE_PLANTILLA,
  construirPlantilla,
  prepararCatalogos,
  prepararContextoArchivo,
  validarFila,
} from "./plantillaAsignacionRelojes";

const columnasPreview = [
  columnaOperacion,
  {
    title: "Número Empleado",
    dataIndex: "empleadoNumero",
    key: "empleadoNumero",
    width: 130,
  },
  { title: "Empleado", dataIndex: "empleadoNombre", key: "empleadoNombre", width: 240 },
  {
    title: "Reloj Checador",
    dataIndex: "relojChecadorNombre",
    key: "relojChecadorNombre",
    width: 280,
  },
  {
    title: "Usuario Reloj",
    dataIndex: "usuarioRelojChecador",
    key: "usuarioRelojChecador",
    width: 120,
    render: (valor) =>
      valor ? valor : <span style={{ color: "#8c8c8c" }}>(siguiente libre)</span>,
  },
  { title: "Estado", dataIndex: "estadoNombre", key: "estadoNombre", width: 130 },
];

const instrucciones = [
  <>
    <b>Descarga la plantilla.</b> La hoja <b>Asignaciones</b> ya viene con todas
    tus asignaciones actuales, con su <code>ID</code> y su <code>Estado</code>. Las
    hojas <b>Empleados</b> y <b>Relojes</b> son de consulta.
  </>,
  <>
    Para <b>deshabilitar</b>: cambia la columna <b>Estado</b> de esa fila a{" "}
    <b>Deshabilitado</b>. Al deshabilitar, el empleado también{" "}
    <b>se borra del reloj checador</b> (usuario, huellas y rostro).
  </>,
  <>
    Para <b>habilitar</b>: cambia <b>Estado</b> a <b>Activo</b>. Se le vuelven a
    mandar al reloj sus credenciales.
  </>,
  <>
    Para <b>crear</b> una asignación nueva: agrega una fila al final,{" "}
    <b>deja la columna ID vacía</b> y llena Número Empleado, Reloj Checador y
    Estado = Activo. Si dejas <b>Usuario Reloj</b> vacío, se le pone el siguiente
    número libre de ese reloj.
  </>,
  <>
    Desde el Excel <b>no</b> se le puede cambiar el empleado, el reloj ni el
    usuario a una asignación que ya existe (una fila que ya trae ID): eso se hace
    en la pantalla de Asignación de Relojes. Si lo intentas, la fila sale
    reportada en <code>errores.xlsx</code> y no se aplica.
  </>,
  <>
    Si a un empleado que ya está activo en un reloj le pones una fila{" "}
    <b>nueva</b> con otro Usuario Reloj, se marca como <b>Reemplazar</b>: se
    deshabilita la anterior (borrándola del reloj) y se crea la nueva, para que no
    queden dos usuarios de la misma persona checando.
  </>,
  <>
    Borrar una fila del archivo <b>no borra nada</b>: las filas que no vengan se
    quedan como están.
  </>,
  <>
    El alta y la baja en el reloj físico <b>no son instantáneas</b>: se encolan y
    el dispositivo se las lleva poco a poco cada vez que se conecta. Revisa cómo
    va en <b>Relojes Checadores → Información del Reloj Checador</b>.
  </>,
];

const ImportarAsignacionRelojes = (props) => (
  <ImportadorExcelGenerico
    {...props}
    titulo="Importar / Actualizar Asignaciones de Relojes Checadores"
    nombreEntidadPlural="asignaciones de reloj"
    endpointDatosImportar="asignacionesRelojes/datosParaImportarAsignacionesRelojes"
    endpointImportar="asignacionesRelojes/importarAsignacionesRelojes"
    nombrePlantilla={NOMBRE_PLANTILLA}
    prepararCatalogos={prepararCatalogos}
    prepararContextoArchivo={prepararContextoArchivo}
    construirPlantilla={construirPlantilla}
    validarFila={validarFila}
    columnasPreview={columnasPreview}
    instrucciones={instrucciones}
    permitirEdicion
    mostrarSwitchSoloCambios
    etiquetasAccion={ETIQUETAS_ACCION}
    // Cada fila encola varias AccionReloj y lee al empleado completo (las
    // plantillas biométricas pesan), así que el archivo se manda en bloques.
    tamanoLote={25}
    onImportSuccess={(resData) =>
      mostrarResumenImportacion(resData, { entidad: "asignaciones de reloj" })
    }
  />
);

export default ImportarAsignacionRelojes;
